const LOGIN = "api/common/v2/admin/login/";
const ACCOUNTList = "api/common/v2/account/";
const ACCOUNT_LIST_V1 = "api/common/v2/account/";
const ACCOUNT_LIST_V2 = "api/common/v2/account/";
const USERList = "api/common/v2/user/";
const USER_LIST_V2 = "api/common/v2/user/";
const ADMINUserCreate = "api/common/v2/user-create/";
const AdminUserCount = "api/common/v2/admin/count/";
const USER = "api/common/v2/user/";
const COMMON_V2 = "api/common/v2/";
const IMPERSONATE_START = "api/common/v2/admin/impersonate/start/";
const IMPERSONATE_END = "api/common/v2/admin/impersonate/end/";
const IMPERSONATE_EXCHANGE = "api/common/v2/admin/impersonate/exchange/";
const APP_CONFIG = "api/app-config";
const ONBOARDING_STEP = "api/common/v2/onboarding-step/";
const ADOPTION_SCORING_CONFIG = "api/common/v2/adoption/scoring-config/";
const ADOPTION_IMPACT_PREVIEW = "api/common/v2/adoption/impact-preview/";
const ACCOUNT_ADOPTION = "api/common/v2/account/"; // v2 base — append {accountId}/adoption/
export const API = {
  LOGIN,
  ACCOUNTList,
  ACCOUNT_LIST_V1,
  ACCOUNT_LIST_V2,
  USERList,
  USER_LIST_V2,
  ADMINUserCreate,
  AdminUserCount,
  USER,
  COMMON_V2,
  IMPERSONATE_START,
  IMPERSONATE_END,
  IMPERSONATE_EXCHANGE,
  APP_CONFIG,
  ONBOARDING_STEP,
  ADOPTION_SCORING_CONFIG,
  ADOPTION_IMPACT_PREVIEW,
  ACCOUNT_ADOPTION,
};
